module.exports = __webpack_public_path__ + "static/media/46_Print.3f060e75.png";